module.exports = __webpack_public_path__ + "static/mobileheader-69b0bac9ca686e6d48237f547b018fd7.jpg";